var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7616_120705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.65 18.9625L3.6125 20.625C3.8125 20.975 4.1 21.25 4.4375 21.45L7.875 15.5H1C1 15.8875 1.1 16.275 1.3 16.625L2.65 18.9625Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9125 8.50078L8.475 2.55078C8.1375 2.75078 7.85 3.02578 7.65 3.37578L1.3 14.3758C1.10368 14.7182 1.00026 15.106 1 15.5008H7.875L11.9125 8.50078Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3875 21.45C19.725 21.25 20.0125 20.975 20.2125 20.625L20.6125 19.9375L22.525 16.625C22.725 16.275 22.825 15.8875 22.825 15.5H15.9495L17.4125 18.375L19.3875 21.45Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9125 8.5L15.35 2.55C15.0125 2.35 14.625 2.25 14.225 2.25H9.59998C9.19998 2.25 8.81248 2.3625 8.47498 2.55L11.9125 8.5Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.95 15.5H7.875L4.4375 21.45C4.775 21.65 5.1625 21.75 5.5625 21.75H18.2625C18.6625 21.75 19.05 21.6375 19.3875 21.45L15.95 15.5Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.35 8.87578L16.175 3.37578C15.975 3.02578 15.6875 2.75078 15.35 2.55078L11.9125 8.50078L15.95 15.5008H22.8125C22.8125 15.1133 22.7125 14.7258 22.5125 14.3758L19.35 8.87578Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7616_120705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.825,
    height: 19.5,
    fill: "white",
    transform: "translate(1 2.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveIcon);
export default __webpack_public_path__ + "static/media/driveIcon.cfda7381bf15ed683ed18444896fd09d.svg";
export { ForwardRef as ReactComponent };